/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".export-buttons[_ngcontent-%COMP%]{padding-top:10px}\n/*# sourceMappingURL=export-dialog.component.css.map*/"];
export { styles as styles };
